import { gsap } from 'gsap';

const initAccordions = () => {
  // open accordion
  const openAccordion = (accordion) => {
    let toggle = accordion.querySelector('.accordion-component_toggle');
    let contentWrapper = accordion.querySelector('.accordion-component_content-wrapper');
    let content = accordion.querySelector('.accordion-component_content');
    let contentHeight = content.offsetHeight;
    let duration = contentHeight * 0.0004;
    if(duration < 0.3) duration = 0.3;

    // check if there are any open accordions
    let accordionGroup = accordion.closest('.accordion-component_list');
    if(accordionGroup && accordionGroup.hasAttribute('data-open-one')) {
      accordionGroup.querySelectorAll('.accordion-component--open').forEach((openAccordion) => {
        closeAccordion(openAccordion, duration);
      });
    }

    gsap.fromTo(contentWrapper, {
      height: 0,
    }, {
      height: contentHeight,
      duration: duration,
      ease: 'power1.inOut',
      onComplete: function() {
        gsap.set(contentWrapper, { height: 'auto' });
      }
    });

    accordion.classList.add('accordion-component--open');
    toggle.setAttribute('aria-expanded', true);
    contentWrapper.setAttribute('aria-hidden', false);
  }

  // close accordion
  const closeAccordion = (accordion, duration) => {
    let toggle = accordion.querySelector('.accordion-component_toggle');
    let contentWrapper = accordion.querySelector('.accordion-component_content-wrapper');
    let content = accordion.querySelector('.accordion-component_content');
    let contentHeight = content.offsetHeight;

    if(duration === undefined) {
      duration = contentHeight * 0.0004;
      if(duration < 0.3) duration = 0.3;
    }

    gsap.fromTo(contentWrapper, {
      height: contentHeight
    }, {
      height: 0,
      duration: duration,
      ease: 'power1.inOut'
    });

    accordion.classList.remove('accordion-component--open');
    toggle.setAttribute('aria-expanded', false);
    contentWrapper.setAttribute('aria-hidden', true);
  }

  document.querySelectorAll('.accordion-component').forEach((accordion, index) => {
    const toggle = accordion.querySelector('.accordion-component_toggle');

    if(toggle) {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();

        if(accordion.classList.contains('accordion-component--open')) {
          closeAccordion(accordion);
        } else {
          openAccordion(accordion)
        }
      });
    }

    // open first accordion
    let accordionGroup = accordion.closest('.accordion-component_list');
    if(accordionGroup && accordionGroup.hasAttribute('data-open-first') && index === 0) {
      openAccordion(accordion);
    }
  });
};

export { initAccordions };